<div class="modal-content">
    <div class="header">
        <h3>View Alert</h3>
        <img src="assets/icons/close-sm.svg" alt="" (click)="modal.deny(undefined)">
    </div>

    <div class="contents">
        <div class="content">
            <h3>ALERT SCENARIO</h3>
            <span> {{modal.context.data.alertScenarioName}} </span>
        </div>

        <div class="content variables">
            <h3>VARIABLES</h3>
            <ul>
                <li> {{modal.context.data.name}} </li>
                <li>within {{parseJson(modal.context.data.configuration).timeframe}} minutes </li>
                <li> {{parseJson(modal.context.data.configuration).minimumCount}} count</li>
            </ul>
        </div>

        <div class="content">
            <h3>DESCRIPTION</h3>
            <span> {{modal.context.data.description}} </span>
        </div>
        <div class="content">
            <h3>NOTIFICATION PREFERENCE</h3>
            <span>Slack</span>
            <ul>
                <li *ngFor="let slackPreference of modal.context.data.slack"> {{slackPreference?.slackChannel}} </li>
            </ul>

            <span>Email</span>
            <ul>
                <li *ngFor="let emailPreference of modal.context.data.email"> {{emailPreference?.emailAddress}} </li>
            </ul>
        </div>

        <div class="content">
            <h3>CREATED BY</h3>
            <span> {{modal.context.data.createdBy ? (modal.context.data.createdBy | createdBy) : '---' }}</span>
        </div>
        <div class="content">
            <h3>DATE CREATED</h3>
            <span> {{modal.context.data.dateCreated ? (modal.context.data.dateCreated | date) : '---' }}</span>
        </div>

        <div class="content">
            <h3>LAST UPDATED</h3>
            <span> {{modal.context.data.dateModified ? (modal.context.data.dateModified | date) : '---' }}</span>
        </div>
        <div class="content">
            <h3>LAST UPDATED BY</h3>
            <span> {{modal.context.data.modifiedBy ? (modal.context.data.modifiedBy | createdBy) : '---' }}</span>
        </div>
    </div>

    <div class="ctrl-btns">
        <button class="cancel">Cancel</button>
    </div>
</div>